import React from "react";
import ReactDOM from "react-dom/client";
import ConfirmationModal from "./ConfirmationModal";

interface ConfirmationOptions {
  title?: string;
  text?: string;
  confirmButtonText?: string;
  cancelButtonText?: string;
}

class ConfirmationService {
  private container: HTMLDivElement | null = null;
  private root: ReactDOM.Root | null = null;

  private createContainer() {
    if (!this.container) {
      this.container = document.createElement("div");
      this.container.id = "confirmation-modal-root";
      document.body.appendChild(this.container);
      this.root = ReactDOM.createRoot(this.container);
    }
    return this.root!;
  }

  private removeContainer() {
    if (this.container && this.root) {
      this.root.unmount();
      this.container.remove();
      this.container = null;
      this.root = null;
    }
  }

  async show(
    title: string = "Are you sure?",
    text: string = "This action cannot be undone!",
    confirmButtonText: string = "Yes, do it!",
    cancelButtonText: string = "Cancel"
  ): Promise<boolean> {
    return new Promise((resolve) => {
      const root = this.createContainer();

      const handleClose = () => {
        this.removeContainer();
        resolve(false);
      };

      const handleConfirm = () => {
        this.removeContainer();
        resolve(true);
      };

      root.render(
        <ConfirmationModal
          isOpen={true}
          onClose={handleClose}
          onConfirm={handleConfirm}
          title={title}
          text={text}
          confirmButtonText={confirmButtonText}
          cancelButtonText={cancelButtonText}
        />
      );
    });
  }
}

export const confirmationService = new ConfirmationService();
